<template>
    <div class="container-fluid" id="dvcrud">
        <detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="false"></detalhespedido>
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edconteudopesq">Nr. Guia:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pid" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-10 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-9 col-lg-3">
								<span class="lblselect2">Veículo:</span>
								<select id="cbveiculopesq" data-placeholder="Selecione uma filial" v-model="pidveiculo" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-9 col-lg-3">
								<span class="lblselect2">Motorista:</span>
								<select id="cbmotoristapesq" data-placeholder="Selecione uma filial" v-model="pidmotorista" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>                                                        
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>	
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacao">Situação:</label>
                                <select name="cbsituacao" class="form-control form-control-sm" id="cbsituacao" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Em digitação</option>
                                    <option value="1">Em rota</option>
                                    <option value="2">Todas</option>
                                </select>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbefetivadas">Efetivadas:</label>
                                <select name="cbefetivadas" class="form-control form-control-sm" id="cbefetivadas" v-model="pefetivada" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todas</option>
                                </select>
                            </div>                            						                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstguiasrotas"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="slot_id" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: 600;">{{ mtdformatarzeros(item.row.id, 8) }} </span>
                                    </template>
                                    <template slot="slot_detalhes" slot-scope="item">
                                        <i @click.prevent="mtddetalhes(item.row)" class="fa fa-info-circle icon-detalhes" title="Detalhes da guia de rota"></i>
                                    </template>                                    
                                    <template slot="slot_dtemissao" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px;">{{ item.row.dtemissao }}</span>
                                    </template>                                    
                                    <template slot="slot_situacao" slot-scope="item">
										<span v-if="parseInt(item.row.situacao) === 0" class="badge badge-primary badge-pill" style="background-color: #EEA435; font-size: 16px;" title="Em digitação"><i class="fa fa-keyboard-o"></i></span>
                                        <span v-else class="badge badge-primary badge-pill" style="background-color: #6BA2D0; font-size: 16px;" title="Em rota"><i class="fa fa-truck"></i></span>
                                    </template>                                    
									<template slot="slot_fantasiafilial" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: bold;">{{ item.row.fantasiafilial }}</span>
									</template>	 
									<template slot="slot_veiculo" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: bold;">{{ item.row.descveiculo }}</span>
									</template>
									<template slot="slot_nomemotorista" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: bold;">{{ item.row.nomemotorista }}</span>
									</template>                                                                        	                                                                       
                                    <template slot="slot_efetivada" slot-scope="item">
                                        <span v-if="parseInt(item.row.efetivada) === 1" class="badge badge-primary badge-pill" style="background-color: #5A956A;  font-size: 16px;"><i class="fa fa-check"></i></span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_dtefetivacao" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px; font-weight: bold;">{{ item.row.dtefetivacao }}</span>
                                    </template>                                                                                                            
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>                                        
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstguiasrotas.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
							<div class="col-sm-12 col-md-10 col-lg-4">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-9 col-lg-3">
								<span class="lblselect2">*Veículo:</span>
								<select id="cbveiculo" data-placeholder="Selecione uma filial" v-model="vidveiculo" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-9 col-lg-3">
								<span class="lblselect2">*Motorista:</span>
								<select id="cbmotorista" data-placeholder="Selecione uma filial" v-model="vidmotorista" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtentrega">*Dt. Entrega:</label>
								<div class="input-group">
									<date-picker id="eddtentrega" v-model="vdtentrega" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbsituacao">Situação:</label>
                                <select name="cbsituacao" class="form-control form-control-sm" id="cbsituacao" v-model="vsituacao" v-bind:disabled="ativadesativa">
                                    <option value="0">Em digitação</option>
                                    <option value="1">Em rota</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtsituacao">*Dt. Situação:</label>
								<div class="input-group">
									<date-picker id="eddtsituacao" v-model="vdtsituacao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                                                        
							<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
								<button type="button" class="btn btn-success btn-block btn-sm" v-bind:disabled="ativadesativa" @click.prevent="mtdadicionarpedidos()" style="margin-top: 22px;"><i class="fa fa-plus"></i> Pedidos</button>
							</div>                                                                                                                                            
							<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
								<button type="button" class="btn btn-secondary btn-block btn-sm" v-bind:disabled="ativadesativa" @click.prevent="mtdexcluirpedidos()" style="margin-top: 22px;"><i class="fa fa-trash"></i> Excluir</button>
							</div>                                                                                     
                        </div>
                        <div class="row" style="margin-top: 15px;">
							<div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Ítens da nota</a>
                                    </li>
								    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>																		
                                </ul>
								<div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
									<div id="dvitens" class="container-fluid tab-pane active">
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table ref="reflstpedidos"
                                                        :rows="lstpedidos"
                                                        :columns="columnspedidos"
                                                        :config="configpedidos"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  --> 
                                                    <template slot="slot_detalhesped" slot-scope="item">
                                                        <i @click.prevent="mtddetalhespedido(item.row.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i>
                                                    </template>
                                                    <template slot="slot_idpedido" slot-scope="item">
										                <span style="color: #6c757d; font-size: 12px; font-weight: 600;">{{ mtdformatarzeros(item.row.idpedido, 8) }} </span>
                                                    </template>
                                                    <template slot="slot_cliente" slot-scope="item">
										                <span style="color: #6c757d; font-size: 12px; font-weight: 600;">{{ item.row.nomecliente }}</span>
									                </template>
                                                    <template slot="slot_dtfatura" slot-scope="item">
                                                        <span style="color: #6c757d; font-size: 12px; font-weight: 600;">{{ item.row.dtfatura }}</span>
                                                    </template>
                                                    <template slot="slot_totalgeral" slot-scope="item">										
                                                        <span style="color: #6c757d; font-weight: bold;  color: #5A956A;">{{ mtdformatavalordecimal(parseFloat(item.row.totalgeral), 2) }}</span>
                                                    </template>
                                                    <template slot="slot_descplano" slot-scope="item">
                                                        <span style="color: #6c757d; font-size: 12px;">{{ item.row.descplano }}</span>
                                                    </template>
                                                    <template slot="slot_descrota" slot-scope="item">
                                                        <span style="color: #6c757d; font-size: 12px; font-weight: 600; color: #EEA435;">{{ item.row.descrota }}</span>
                                                    </template>                                                                                                                                                            										                                                    
                                                </vue-bootstrap4-table>
                                            </div>                                            
										</div>
									</div>
									<div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>											
										</div>
									</div>                                    
								</div>                                                                        
							</div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Menu do guia --> 
		<div class="modal fade" id="mdmenuguia" tabindex="-1">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(menuguia.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(menuguia)" data-dismiss="modal"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(menuguia)" data-dismiss="modal"><i class="fa fa-trash"></i> EXCLUIR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdefetivar(menuguia.id)" data-dismiss="modal"><i class="fa fa-check"></i> EFETIVAR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimeguiarota(menuguia.id, '0')" data-dismiss="modal"><i class="fa fa-print"></i> IMPRIMIR GUIA DE ROTA</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimeguiarota(menuguia.id, '1')" data-dismiss="modal"><i class="fa fa-file-excel-o"></i> EXPORTAR GUIA EXCEL</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>

        <!-- Modal da consulta de pedidos -->
		<div class="modal fade" id="mdconsultarpedidosguiaentrega">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 class="modal-title"><i class="fa fa-search"></i> Consulta de pedidos para importação</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">                            
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Pedido:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'######'" class="form-control form-control-sm" v-model="pidpedidopesq" @keyup="mtdlimpar_listagem()">
                            </div>  
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesqpedidos" data-placeholder="Selecione uma filial" v-model="pidfilialpesq" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                                                      
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Cliente:</span>
								<select id="cbclientepesq" data-placeholder="Selecione um cliente" v-model="pidclientepesq" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Vendedor:</span>
								<select id="cbvendedorpesq" data-placeholder="Selecione um vendedor" v-model="pidvendedorpesq" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Rota:</span>
								<select id="cbrotapesq" data-placeholder="Selecione uma rota" v-model="pidrotapesq" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtipopesq">Tipo:</label>
                                <select name="cbtipopesq" class="form-control form-control-sm" id="cbtipopesq" v-model="ptipopesq" @change="mtdlimpar_listagempesq()">
                                    <option value="0">Pedidos</option>
                                    <option value="1">Orçamentos</option>
                                    <option value="2">Ordens de serviço</option>
                                    <option value="4">Todos</option>
                                </select>
                            </div>				
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodopesq" v-bind="selecionaperiodopesq">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtinipesq" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodopesq"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfimpesq" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodopesq"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>														
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistrospesq" @change="mtdlimpar_listagempesq()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisapesq()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div id="dvlistagempedidospesq" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstpedidospesq"
                                        :rows="lstpedidospesq"
                                        :columns="columnspesqpedido"
                                        :config="configpedidospesq"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    							
                                    <template slot="id_f" slot-scope="item">
										{{ mtdformatarzeros(item.row.id, 8) }} 
                                        <i v-if="parseInt(item.row.entregaexterna) === 1" class="fa fa-truck" title="Entrega externa" style="color: #0acf97; margin-left: 3px; transform: scale(-1, 1);"></i>
                                    </template>

                                    <template slot="slot_tipo" slot-scope="item">
                                        <template v-if="parseInt(item.row.tipo) === 0">
											<span class="badge badge-primary badge-pill" style="background-color: #6BA2D0;">PEDIDO</span>
                                        </template>
                                        <template v-else-if="parseInt(item.row.tipo) === 1">
											<span class="badge badge-primary badge-pill" style="background-color: #EEA435;">ORÇAMENTO</span>
                                        </template>
                                        <template v-else>
											<span class="badge badge-primary badge-pill" style="background-color: #A42F11;">O. S.</span>
                                        </template>										
                                    </template>
                                    <template slot="slot_dtemissao" slot-scope="item">
                                        {{ item.row.dtemissao }}
                                    </template>																		
									<template slot="slot_totalgeral" slot-scope="item">
										<span style="color: #6c757d; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.totalgeral), 2) }}</span>
									</template>																						
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-4">
                                <v-pagination style="padding: 5px 10px 5px 10px;" class="border rounded"
                                        v-model="pagina_atualpesq"
                                        :page-count="pqtd_paginaspesq"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>            
                            </div>    
                            <div class="col-md-8">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpedidospesq.length}}</span>
                                    </li>
                                </ul>
                            </div>                            
						</div>
					</div>        
					<div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdimportarselecionados()"><i class="fa fa-check"></i> Importar</button>                        
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>

        <!-- Modal para exibir detalhes da guia de rota  -->
        <div class="modal fade" id="mddetalhesguiarota" tabindex="-1" aria-labelledby="mddetalhesguiarota" aria-hidden="true">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdldetalhesguiarota"><i class="fa fa-info-circle"></i> Detalhes da guia de rota</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="ednrpeddet">Nr. Guia:</label>
                                    <input type="text" class="form-control form-control-sm text-right font-weight-bold text-secondary" id="ednrpeddet" v-bind:value="mtdformatarzeros(detguia.id, 8)"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                    <label for="eddtemissaodet">Emissão:</label>
                                    <input type="text" class="form-control form-control-sm text-right" id="eddtemissaodet" v-model="detguia.dtemissao"
                                        data-bv-group=".group" disabled/>
                                </div>                                
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edfilialdet">Filial:</label>
                                    <input type="text" class="form-control form-control-sm" id="edpmod" v-bind:value="detguia.idfilial+' - '+detguia.fantasiafilial"
                                        data-bv-group=".group" disabled/>
                                </div>							
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edveiculodet">Veículo:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edveiculodet" v-model="detguia.descveiculo"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edmotoristadet">Motorista:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edmotoristadet" v-model="detguia.nomemotorista"
                                        data-bv-group=".group" disabled/>
                                </div>                                
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                    <label for="edsituacaodet">Situação:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edsituacaodet" v-bind:value="parseInt(detguia.situacao) === 0 ? 'Em Digitação - '+detguia.dtsituacao : 'Em Rota - '+detguia.dtsituacao"
                                        data-bv-group=".group" disabled/>
                                    <span v-if="parseInt(detguia.situacao) === 0" class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #EEA435; font-size: 16px;" title="Em digitação"><i class="fa fa-keyboard-o"></i></span>
                                    <span v-else class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #6BA2D0; font-size: 16px;" title="Em rota"><i class="fa fa-truck"></i></span>                                        
                                </div>                                                                
                                <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4" v-show="parseInt(detguia.efetivada) === 1">
                                    <label for="edefetivadadet">Efetivada:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase" id="edefetivadadet" v-bind:value="parseInt(detguia.efetivada) === 1 ? detguia.dtefetivacao : ''"
                                        data-bv-group=".group" disabled/>
                                    <span class="badge badge-primary badge-pill bdg-det-icone-guia" style="background-color: #5A956A; font-size: 16px;"><i class="fa fa-check"></i></span>
                                </div>                                                                             
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="table-responsive">
                                        <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                            <thead class="thead-dark">
                                            <tr>
                                                <!-- <th v-show="parseInt(detguia.efetivada) === 0" @click.prevent="mtdmarcartodas()"><i class="fa fa-plus-square-o" style="cursor: pointer; font-size: 16px; position: absolute; top: 20px; left: 25px;"></i></th> -->
                                                <th>Nr. Pedido:</th>
                                                <th></th>
                                                <th>Cliente:</th>
                                                <th>Dt. fatura:</th>
                                                <th>Total:</th>
                                                <th>Plano:</th>
                                                <th>Rota:</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in detguia.pedidos" v-bind:key="index" style="font-size: 12px;">
                                                    <!-- <td v-show="parseInt(detguia.efetivada) === 0" style="cursor: pointer; width: 30px; font-weight: bold; text-align: center; font-size: 18px;" @click.prevent="mtdhabilita(index)">
                                                        <i v-if="parseInt(item.selecionado) === 1" class="fa fa-check-square"></i>
                                                        <i v-else class="fa fa-square-o"></i>
                                                    </td> -->
                                                    <td style="width: 90px; font-weight: bold;">{{mtdformatarzeros(item.idpedido, 8)}}</td>
                                                    <td style="width: 30px; text-align: center;"><i @click.prevent="mtddetalhespedido(item.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i></td>
                                                    <td>{{item.nomecliente}}</td>
                                                    <td style="width: 140px;">{{item.dtfatura}}</td>
                                                    <td style="width: 120px; text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(item.totalgeral), 2)}}</td>
                                                    <td style="width: 180px;">{{item.descplano}}</td>
                                                    <td style="width: 180px;">{{item.descrota}}</td>
                                                </tr>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
					</div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" style="width: 200px;" @click.prevent="mtdimprimeguiarota(detguia.id, '0')"><i class="fa fa-truck"></i> Guia de rota</button>                        
                        <button type="button" class="btn btn-info btn-sm" style="width: 200px;" @click.prevent="mtdimprimeguiarota(detguia.id, '1')"><i class="fa fa-file-excel-o"></i> Exportar excel</button>                        
                        <!-- <button v-show="parseInt(detguia.efetivada) === 0" type="button" class="btn btn-success btn-sm" style="width: 200px;" @click.prevent="mtdimprimeguiaseparacao()"><i class="fa fa-print"></i> Guia de conferência</button>                        
                        <button v-show="parseInt(detguia.efetivada) === 0" type="button" class="btn btn-info btn-sm" style="width: 200px;" @click.prevent="mtdimprimirguiasintetizada()"><i class="fa fa-list"></i> Guia sintetizada</button>                         -->
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 200px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>					
				</div>
			</div>
		</div>		
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
    import DetalhesPedido from '../components/cmpdetalhespedido.vue'

    export default {
        name: 'cadguiasrotas',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'        : BreadCrumb,
            'detalhespedido'  	: DetalhesPedido,
        },
        data: function() {
            return {
                menuguia     : [],
                //variável para visualização do detalhe do pedido
                vidpedidodet : '',
                ////////////////////
                //variável para visualização dos detalhes da guia de rota
                detguia      : [],
                ////////////////////
                lstguiasrotas: [],
                pid          : '',
                pidfilial    : null,
                pidveiculo   : null,
                pidmotorista : null, 
                psituacao    : 2, 
                pefetivada   : 2,
                pfiltroperiodo : 1, 
				pdtini       : util.DataAtual(true),
				pdtfim       : util.DataAtual(true),	                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vidfilial           : null,
                vidmotorista        : null,
                vidveiculo          : null,
                vdtemissao          : util.DataAtual(true),
                vdtentrega          : util.DataAtual(true),
                vsituacao           : 0,
                vdtsituacao         : util.DataAtual(true),
                vobservacoes        : '',
                lstpedidos          : [],


                //variável para habilitação dos campos
                ativadesativa       : true,


                //Consulta dos pedidos
				lstpedidospesq 		: [],
                pidfilialpesq           : null,
				pidpedidopesq    		: '',
				pidclientepesq	 		: null,
				pidvendedorpesq  		: null,
                pidrotapesq             : null,
				ptipopesq				: 4,
				pfiltroperiodopesq      : 1,
				pdtinipesq       		: util.DataAtual(true),
				pdtfimpesq       		: util.DataAtual(true),				
                pqtdregistrospesq		: 10,
                pqtd_paginaspesq 		: 1,
                pagina_atualpesq 		: 1,
                pqtd_total_registrospesq: 0,
                columnspesqpedido: [
                    {
                        label: "Nr. Pedido",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
						row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Tipo",
                        name: "tipo",
                        sort: true,
                        slot_name: "slot_tipo",
                        row_classes: "def-col-tipo",
					},																			
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
						sort: true,
						slot_name: "slot_dtemissao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Rota",
                        name: "descrota",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                    
                    {
                        label: "Filial",
                        name: "fantasia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vendedor",
                        name: "nomevendedor",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Plano",
                        name: "descplano",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },					
                    {
                        label: "Valor",
                        name: "totalgeral",
                        sort: true,
                        slot_name: "slot_totalgeral",
						column_classes: "def-col-totalgeral",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					}               
                ],
                configpedidospesq: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },

                    show_refresh_button : false,
                    show_reset_button : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'GUIAS DE ROTAS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "",
                        name: "situacao",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "slot_id",
                        row_classes: "def-col-cod",
                    },                    
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_dtemissao",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-dtemissao",
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                    },
                    {
                        label: "Filial",
                        name: "fantasiafilial",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_fantasiafilial",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Veículo",
                        name: "descveiculo",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_veiculo",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Motorista",
                        name: "nomemotorista",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomemotorista",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Efetivada",
                        name: "efetivada",
                        sort: true,
                        slot_name: "slot_efetivada",
                        row_classes: "def-col-efetivada",
                    },
                    {
                        label: "Dt. Efetivação",
                        name: "dtefetivacao",
                        sort: true,
                        slot_name: "slot_dtefetivacao",
                        row_classes: "def-col-dtefetivacao",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    }
                ],
                columnspedidos: [                  
                    {
                        label: "",
                        name: "id",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhesped",
                        row_classes: "def-col-detalhesped",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },                    
                    {
                        label: "Nr.Pedido",
                        name: "id",
                        sort: true,
                        slot_name: "slot_idpedido",
						row_text_alignment: "text-center",
						column_text_alignment: "text-left",
						row_classes: "def-col-idpedidoped",
					},                                        
                    {
                        label: "Cliente",
                        name: "nomecliente",                        
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_cliente",
                        row_classes: "def-col-nomeclienteped",                        
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Dt. Fatura",
                        name: "dtfatura",
                        sort: true,
                        slot_name: "slot_dtfatura",
                        row_classes: "def-col-dtfaturaped",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },
                    {
                        label: "Total",
                        name: "totalgeral",
                        sort: true,                        
                        slot_name: "slot_totalgeral",
                        row_classes: "def-col-totalgeralped",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"                        
                    },                    
                    {
                        label: "Plano",
                        name:  "descplano",
                        sort: true,
                        slot_name: "slot_descplano",
                        row_classes: "def-col-descplanoped",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    },                    
                    {
                        label: "Rota",
                        name:  "descrota",
                        sort: true,
                        slot_name: "slot_descrota",
                        row_classes: "def-col-descrotaped",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"                        
                    }  
                ],
                configpedidos: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },

                    show_refresh_button : false,
                    show_reset_button : false
                },                                
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                }
            }
        },
        methods:{
			mtdmostrarmenu(guia){				
				this.menuguia = guia;
				$('#mdmenuguia').modal('show');
			},            
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},            
            mtddefinicoesiniciais(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
			    let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';

				let sqlinimot = 'select id, nome from tbmotoristas ';
			    let sqlfimmot = 'where ativo=0 and upper(nome) like upper("%@@%")';                                

				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});
				$("#cbveiculopesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbveiculos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidveiculo = $("#cbveiculopesq").val();
                    vself.mtdlimpar_listagem();
				});   

				$("#cbmotoristapesq").select2({
					id: function (e) {return e.id},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqlinimot,
								sqlfim	: sqlfimmot,
								cpid	: 'id',
								cpdesc	: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidmotorista = $("#cbmotoristapesq").val();
                    vself.mtdlimpar_listagem();
				});                

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
				});
                
				$("#cbveiculo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbveiculos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidveiculo = $("#cbveiculo").val();
				});   

				$("#cbmotorista").select2({
					id: function (e) {return e.id},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqlinimot,
								sqlfim	: sqlfimmot,
								cpid	: 'id',
								cpdesc	: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidmotorista = $("#cbmotorista").val();
				});
                
				$('#mdconsultarpedidosguiaentrega').on('show.bs.modal', function (e) {
                    vself.lstpedidospesq	        = [];
                    vself.pidpedidopesq    		    = '';
                    vself.pidclientepesq	 	    = null;
                    vself.pidfilialpesq             = vself.$store.state.filialpadrao.codfil;
                    vself.pidvendedorpesq  		    = null;
                    vself.ptipopesq				    = 4;
                    vself.pidentificadorpesq	    = '';
                    vself.pnrseriepesq			    = '';
                    vself.pfiltroperiodopesq        = 1;
                    vself.pdtinipesq       		    = util.DataAtual(true);
                    vself.pdtfimpesq       		    = util.DataAtual(true);				
                    vself.pqtdregistrospesq		    = 10;
                    vself.pqtd_paginaspesq 		    = 1;
                    vself.pagina_atualpesq 		    = 1;
                    vself.pqtd_total_registrospesq  = 0;
                    vself.$refs.reflstpedidospesq.selected_items = [];//limpa os ítens selecionados na table 

                    let deffilial  			= new Option(vself.$store.state.filialpadrao.fantasia, vself.pidfilialpesq, true, true);
                    $('#cbfilialpesqpedidos').append(deffilial).trigger('change');

                    $("#cbclientepesq").val(null).trigger('change');
                    $("#cbvendedorpesq").val(null).trigger('change');                    
				});				
				$('#mdconsultarpedidosguiaentrega').on('shown.bs.modal', function (e) {
					$('#edidpedidopesq').focus();
				});

				$('#mddetalhesguiarota').on('hide.bs.modal', function (e) {
					vself.detguia = [];
                    console.log(vself.detguia);
				});

				$("#cbfilialpesqpedidos").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilialpesq = $("#cbfilialpesqpedidos").val();
				});                
				$("#cbclientepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidclientepesq = $("#cbclientepesq").val();
                    vself.mtdlimpar_listagem();
				});
				$("#cbvendedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidvendedorpesq = $("#cbvendedorpesq").val();
                    vself.mtdlimpar_listagempesq();                    
				}); 
				$("#cbrotapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbrotas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidrotapesq = $("#cbrotapesq").val();
                    vself.mtdlimpar_listagempesq();                    
				});
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                rfiltro = this.pid === '' ? '' : ' and gr.id='+this.pid;

				if (this.pidfilial !== null){
					rfiltro = rfiltro + ' and gr.idfilial='+this.pidfilial;
				}

				if (this.pidveiculo !== null){
					rfiltro = rfiltro + ' and gr.idveiculo='+this.pidveiculo;
				}

                if (this.pidmotorista !== null){
					rfiltro = rfiltro + ' and gr.idmotorista='+this.pidmotorista;
				}

                if (parseInt(this.psituacao) < 2){
                    rfiltro = rfiltro + ' and gr.situacao='+this.psituacao;
                }

                if (parseInt(this.pefetivada) < 2){
                    rfiltro = rfiltro + ' and gr.efetivada='+this.pefetivada;
                }

				if (parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and gr.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
				}                

                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadguiasrotas.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaguiasrotas(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaguiasrotas(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadguiasrotas.php');
                retorno.then(function (response) {
                    vself.lstguiasrotas = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstguiasrotas = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.configpedidos.checkbox_rows = true;
                this.vid                = '';
                this.vidfilial          = this.$store.state.filialpadrao.codfil;
                this.vidmotorista       = null;
                this.vidveiculo         = null;
                this.vdtemissao         = util.DataAtual(true);
                this.vdtentrega         = util.DataAtual(true);
                this.vsituacao          = 0;
                this.vdtsituacao        = util.DataAtual(true);
                this.lstpedidos         = [];

                let deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.vidfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');

                $("#cbveiculo").val(null).trigger('change');
                $("#cbmotorista").val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('020Z.012Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE GUIA DE ROTA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstguiasrotas = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and gr.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadguiasrotas.php');
                retorno.then(function (response) {
                    loader.hide();

                    if (parseInt(response.data[0].efetivada) !== 0){
							vself.$toastr.i('Guia de rota já efetivada no sistema!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}

                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('020Z.012Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE GUIA DE ROTA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('020Z.012Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE GUIA DE ROTA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                    this.configpedidos.checkbox_rows = false;
                }
            },
            mtdigualarcampos(registro){
                this.vid                = registro.id;
                this.vidfilial          = registro.idfilial;
                this.vidmotorista       = registro.idmotorista;
                this.vidveiculo         = registro.idveiculo;
                this.vdtemissao         = registro.dtemissao;
                this.vdtentrega         = registro.dtentrega;
                this.vsituacao          = registro.situacao;
                this.vdtsituacao        = registro.dtsituacao;
                this.lstpedidos         = registro.pedidos;

                let deffilial  			= new Option(registro.fantasiafilial, this.vidfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');

                let defveiculo  		= new Option(registro.descveiculo, this.vidveiculo, true, true);
				$('#cbveiculo').append(defveiculo).trigger('change');
                
                let defmotorista  			= new Option(registro.nomemotorista, this.vidmotorista, true, true);
				$('#cbmotorista').append(defmotorista).trigger('change');                

            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'            : vself.vid,
                    'idfilial'      : vself.vidfilial,
                    'idmotorista'   : vself.vidmotorista,
                    'idveiculo'     : vself.vidveiculo,
                    'dtemissao'     : vself.mtdformatadatagravar(vself.vdtemissao),
                    'dtentrega'     : vself.mtdformatadatagravar(vself.vdtentrega),
                    'situacao'      : vself.vsituacao,
                    'dtsituacao'    : vself.mtdformatadatagravar(vself.vdtsituacao),
                    'observacoes'   : vself.vobservacoes,
                    'pedidos'       : vself.lstpedidos
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '020Z.012Z.010Z' : parseInt(this.opcrud) === 2 ? '020Z.012Z.020Z' : '020Z.012Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadguiasrotas.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltroperiodo= 0;
                        vself.pid           = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.psituacao     = 2;
                        vself.pefetivada    = 2;
                        vself.pidfilial     = null;
                        vself.pidveiculo    = null;
                        vself.pidmotorista  = null; 
                        $("#cbfilialpesq").val(null).trigger('change');
                        $("#cbveiculopesq").val(null).trigger('change');
                        $("#cbmotoristapesq").val(null).trigger('change');                                                 
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaguiasrotas(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdadicionarpedidos(){
                $('#mdconsultarpedidosguiaentrega').modal('show');
            },
            mtdlimpar_listagempesq() {
                this.lstpedidospesq             = [];
                this.pagina_atualpesq           = 1;
                this.filtropesq                 = '';
                this.pqtd_total_registrospesq   = 0;
                this.pqtd_paginaspesq           = 0;
            },            
            mtdfiltropesquisapesq(){
                let rfiltro = '';
                if (this.pidpedidopesq !== ''){
                    rfiltro = ' and p.id='+this.pidpedidopesq;
                }
                
                //Filtra somente os faturados e sem guia de rota
                rfiltro = rfiltro + ' and p.stpedido=1 and p.idguiarota=0';

				if (this.pidfilialpesq !== ''){
					rfiltro = rfiltro + ' and p.idfilial='+this.pidfilialpesq;
				}
				if (this.pidclientepesq !== null){
					rfiltro = rfiltro + ' and p.idcliente='+this.pidclientepesq;
				}
				if (this.pidvendedorpesq !== null){
					rfiltro = rfiltro + ' and p.idvendedor='+this.pidvendedorpesq;
				}
				if (this.pidrotapesq !== null){
					rfiltro = rfiltro + ' and c.idrota='+this.pidrotapesq;
				}                
				if(parseInt(this.pfiltroperiodopesq) === 1){
					rfiltro = rfiltro + ' and p.dtemissao between "' + util.InverterData(this.pdtinipesq) + '" and "' + util.InverterData(this.pdtfimpesq) + '"';
				}				
				if (parseInt(this.ptipopesq) < 4){
					rfiltro = rfiltro + ' and p.tipo<>3 and p.tipo='+this.ptipopesq;
				}else{
                    rfiltro = rfiltro + ' and p.tipo<>3';
                }
                return rfiltro;
            },
            mtdexecutapesquisapesq(){
				let vself           = this;				
				let filtro          = vself.mtdfiltropesquisapesq();
				this.pagina_atual   = 1;
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor  : 'qtdregistros'},
					{parametro: 'filtro',       valor  : filtro}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					vself.pqtd_total_registrospesq = parseInt(response.data.qtdregistros);
					let qtdpg                  = Math.ceil(vself.pqtd_total_registrospesq / vself.pqtdregistrospesq);
					vself.pqtd_paginaspesq     = qtdpg > 0 ? qtdpg : 1;
					vself.mtdcarregapedidospesq(1);
				}).catch(function (response) {
					alert('Erro ao consultar registros');
				});				
            },                                    
            mtdcarregapedidospesq(ipagina){
                if (util.verificasessao(this)){
                    var vself       = this;
                    let loader      = this.$loading.show();
                    let filtro      = vself.mtdfiltropesquisapesq();
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : vself.pqtdregistrospesq},
                        {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistrospesq)}
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                    retorno.then(function (response) {
						vself.lstpedidospesq = response.data.pedidos;
						loader.hide();											
                    }).catch(function (response) {
                        vself.lstpedidospesq = [];
                        loader.hide();
                    });
                }
            },
            mtdimportarselecionados(){
                let vself = this;
                let selecionados = vself.$refs.reflstpedidospesq.selected_items;
                if (selecionados.length === 0){
                    vself.$toastr.i('Selecione ao menos um pedido para importação!', 'Atenção!');
                }else{
                    for (let i = 0; i < selecionados.length; i++) {
                        if (!util.findValInArray(vself.lstpedidos, 'idpedido', selecionados[i].id)){
                            let pedtmp = {
                                'idpedido'      : selecionados[i].id,
                                'nomecliente'   : selecionados[i].idcliente + ' - ' + selecionados[i].nomecliente,
                                'dtfatura'      : selecionados[i].dtfatura,
                                'totalgeral'    : selecionados[i].totalgeral,
                                'descplano'     : selecionados[i].descplano,
                                'descrota'      : selecionados[i].descrota
                            };
                            vself.lstpedidos.push(pedtmp);
                        }
                    }
                    $('#mdconsultarpedidosguiaentrega').modal('hide');
                }
            },
            mtdexcluirpedidos(){
                let vself = this;
                let selecionados = vself.$refs.reflstpedidos.selected_items;
                if (selecionados.length > 0){
                    let pedidostmp   = JSON.parse(JSON.stringify(vself.lstpedidos));
                    vself.lstpedidos = [];
                    for (let i = 0; i < selecionados.length; i++) {
                        let inditem = util.getArrayIndexForKey(pedidostmp, 'idpedido', selecionados[i].idpedido);
                        if (inditem > -1){
                            pedidostmp.splice(inditem, 1);
                        }
                    }
                    vself.$refs.reflstpedidos.selected_items = [];
                    vself.lstpedidos = JSON.parse(JSON.stringify(pedidostmp));
                }else{
                    vself.$toastr.i('Não há pedidos selecionados!', 'Atenção!'); 
                }
            },
			mtdimprimeguiarota(idguiarota, gerarexcel){
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirguiarota.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idguiarota='+idguiarota+'&idu='+this.$store.state.usuario.id+
                            '&gerarexcel='+gerarexcel, '_blank');					
			},
            mtdefetivar(idguia){
                let vself =  this;
                if (!util.opcaousuario('020Z.012Z.040Z', vself.$store.state.perfilusuario)){
                    vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma EFETIVAÇÃO DA GUIA DE ROTA?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    vself.mtdconfirmaefetivacao(idguia);
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });
                }
            },
            mtdconfirmaefetivacao(idguia){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'efetivar'},
                    {parametro: 'idguia',       valor : idguia},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.012Z.040Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadguiasrotas.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Guia de rota efetivada com sucesso!', 'Informação!');
                        vself.pfiltroperiodo= 0;
                        vself.pid           = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.psituacao     = 2;
                        vself.pefetivada    = 2;
                        vself.pidfilial     = null;
                        vself.pidveiculo    = null;
                        vself.pidmotorista  = null; 
                        $("#cbfilialpesq").val(null).trigger('change');
                        $("#cbveiculopesq").val(null).trigger('change');
                        $("#cbmotoristapesq").val(null).trigger('change');                                                 
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaguiasrotas(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
			mtddetalhespedido(idpedido){
                this.vidpedidodet = idpedido;
                $('#mddetalhespedido').modal('show');
			},
            mtddetalhes(guia){
                this.detguia = JSON.parse(JSON.stringify(guia));
                $('#mddetalhesguiarota').modal('show');
            },
            mtdaplicaselecao(valoratribuir){
                util.aplicaselecao(this.detguia.pedidos, 'selecionado', valoratribuir);
            },
            mtdmarcartodas(){
                util.marcartodas(this.detguia.pedidos, 'selecionado');
            },
            mtdhabilita(index){
                util.habilita(this.detguia.pedidos, 'selecionado', index);
            },
			mtdimprimeguiaseparacao(){
                if (!util.findValInArray(this.detguia.pedidos, 'selecionado', 1)){
                    this.$toastr.w('Não há pedidos selecionados para a impressão!', 'Atenção!');
                }else{
                    let lstpedidosimp = '';
                    for (let i = 0; i < this.detguia.pedidos.length; i++) {
                        if (parseInt(this.detguia.pedidos[i].selecionado) === 1){
                            lstpedidosimp = lstpedidosimp+', '+this.detguia.pedidos[i].idpedido;
                        }
                    }
                    window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirguiaseparacaorota.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idguiarota='+this.detguia.id+'&idu='+this.$store.state.usuario.id+'&pedidos='+lstpedidosimp.substring(2), '_blank');					
                }
			},
            mtdimprimirguiasintetizada(){
                if (!util.findValInArray(this.detguia.pedidos, 'selecionado', 1)){
                    this.$toastr.w('Não há pedidos selecionados para a impressão!', 'Atenção!');
                }else{
                    let lstpedidosimp = '';
                    for (let i = 0; i < this.detguia.pedidos.length; i++) {
                        if (parseInt(this.detguia.pedidos[i].selecionado) === 1){
                            lstpedidosimp = lstpedidosimp+', '+this.detguia.pedidos[i].idpedido;
                        }
                    }
                    window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirguiaseparacaosintetizada.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idguiarota='+this.detguia.id+'&idu='+this.$store.state.usuario.id+'&pedidos='+lstpedidosimp.substring(2), '_blank');					
                }                
            }                                                
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('020Z.012Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtddefinicoesiniciais();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
				return this.vidfilial === null || this.vidveiculo === null || this.vidmotorista === null || 
				this.lstpedidos.length === 0 || this.vdtemissao === null || this.vdtentrega === null;
            },
			selecionaperiodo() {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
			},            
			selecionaperiodopesq() {
				if(parseInt(this.pfiltroperiodopesq) === 0){
					this.hab_desab_periodopesq = true;
				}else{
					this.hab_desab_periodopesq = false;
				}
			}            
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaguiasrotas(val);
            },
            pagina_atualpesq(val){
                this.mtdcarregapedidospesq(val);
			}
        }
    }
</script>
<style>
    .def-col-opcoes{
        width: 40px !important;        
    }
    .def-col-situacao{
        width: 80px !important;
    }
    .def-col-dtemissao{
        width: 80px !important;
    }
    .def-col-efetivada{
        width: 80px !important;
    }
    .def-col-dtefetivacao{
        width: 140px !important;
    }
    .def-col-detalhes{
        width: 30px !important;
    }
    .bdg-det-icone-guia{
        position: absolute;
        top: 25px;
        right: 18px;
    }
</style>